import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Composant pour protéger les routes accessibles uniquement aux entreprises
const CompanyRoute = () => {
  const { isAuthenticated, isCompany, loading, currentUser } = useAuth();
  
  // Afficher un indicateur de chargement pendant la vérification de l'authentification
  if (loading) {
    return <div>Chargement...</div>;
  }
  
  // Rediriger vers la page de connexion si l'utilisateur n'est pas authentifié
  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace />;
  }
  
  // Rediriger vers la page de connexion si l'utilisateur n'est pas une entreprise
  if (!isCompany) {
    return <Navigate to="/sign-in" replace />;
  }
  
  // Vérifier si c'est la première connexion de l'utilisateur
  if (currentUser && currentUser.first_connexion === true) {
    // Si on est déjà sur la page complete-account, ne pas rediriger pour éviter une boucle
    if (!window.location.pathname.includes('complete-account')) {
      return <Navigate to="/account/complete-account" replace />;
    }
  }
  
  // Rendre les routes enfants si l'utilisateur est une entreprise
  return <Outlet />;
};

export default CompanyRoute;
